<template>
  <div class="homePage">
    <img class="logoImg" :src="Logo">
    <h1>查询系统</h1>
    <div class="box">
      <div class="box-item" @click="go('grade1')">
        <!-- 鱼计划 -->
        <img :src="logo1" alt="">
        <p>成绩查询</p>
      </div>
      <div class="box-item" @click="go('credentials1')">
        <!-- 鱼计划 -->
        <img :src="logo1" alt="">
        <p>理论/实操认证查询</p>
      </div>
      <div class="box-item" @click="go('grade3')">
        <!-- 启明星工程 -->
        <img :src="logo3" alt="">
        <p>成绩查询</p>
      </div>
      <div class="box-item" @click="go('credentials3')">
        <!-- 启明星工程 -->
        <img :src="logo3" alt="">
        <p>认证查询</p>
      </div>
      <div class="box-item" @click="go('grade4')">
        <!-- 精准教学 -->
        <img :src="logo4" alt="">
        <p>成绩查询</p>
      </div>
      <div class="box-item" @click="go('credentials4')">
        <!-- 精准教学 -->
        <img :src="logo4" alt="">
        <p>认证查询</p>
      </div>
      <div class="box-item" @click="go('grade5')">
        <!-- AAC——辅助沟通技术 -->
        <img :src="logo5" alt="">
        <p>成绩查询</p>
      </div>
      <div class="box-item" @click="go('credentials5')">
        <!-- AAC——辅助沟通技术 -->
        <img :src="logo5" alt="">
        <p>认证查询</p>
      </div>
      <div class="box-item" @click="go('credentials2')">
        <!-- 专业助教PA -->
        <img :src="logo2" alt="">
        <p>认证查询</p>
      </div>
      <div class="box-item" @click="go('credentials6')">
        <!-- 实操计划 -->
        <img :src="logo6" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials7')">
        <!-- SLP口语开发特训营 -->
        <img :src="logo7" alt="">
        <p>认证/结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials8')">
        <!-- 社会心智课 -->
        <img :src="logo8" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials9')">
        <!-- 家庭自然语言干预 -->
        <img :src="logo9" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials10')">
        <!-- 思维课程 -->
        <img :src="logo10" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials11')">
        <!-- 社会功能开发课 -->
        <img :src="logo11" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials12')">
        <!-- 居家感统入门课程 -->
        <img :src="logo12" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials13')">
        <!-- 居家感统入门课程 -->
        <img :src="logo13" alt="">
        <p>特殊教育助理查询</p>
      </div>
      <div class="box-item" @click="go('credentials14')">
        <!-- 居家感统入门课程 -->
        <img :src="logo14" alt="">
        <p>行为分析专项技能查询</p>
      </div>
      <div class="box-item" @click="go('credentials15')">
        <!-- 居家感统入门课程 -->
        <img :src="logo15" alt="">
        <p>结业查询</p>
      </div>
      <div class="box-item" @click="go('credentials16')">
        <!-- 居家感统入门课程 -->
        <img :src="logo16" alt="">
        <p>红宝书社交课程</p>
      </div>
      <div class="box-item" @click="go('credentials17')">
        <!-- 居家感统入门课程 -->
        <img :src="logo17" alt="">
        <p>红宝书融合课程</p>
      </div>
      <div class="box-item" @click="go('credentials18')">
        <!-- 居家感统入门课程 -->
        <img :src="logo18" alt="">
        <p>红宝书自理课程</p>
      </div>
      <div class="box-item" @click="go('credentials19')">
        <!-- 居家感统入门课程 -->
        <img :src="logo19" alt="">
        <p>融合全攻略</p>
      </div>
      <div class="box-item" @click="go('credentials20')">
        <!-- 居家感统入门课程 -->
        <img :src="logo20" alt="">
        <p>体脑激活</p>
      </div>
      <div class="box-item" @click="go('credentials21')">
        <!-- 居家感统入门课程 -->
        <img :src="logo21" alt="">
        <p>游戏训练营</p>
      </div>
      <div class="box-item" @click="go('credentials22')">
        <!-- 居家感统入门课程 -->
        <img :src="logo22" alt="">
        <p>语言集训营</p>
      </div>
      <div class="box-item" @click="go('credentials23')">
        <!-- 居家感统入门课程 -->
        <img :src="logo23" alt="">
        <p>注意力训练营</p>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/assets/images/logo.png'
import logo1 from '@/assets/images/logo1.png'
import logo2 from '@/assets/images/logo2.png'
import logo3 from '@/assets/images/logo3.png'
import logo4 from '@/assets/images/logo4.png'
import logo5 from '@/assets/images/logo5.png'
import logo6 from '@/assets/images/logo6.png'
import logo7 from '@/assets/images/logo7.png'
import logo8 from '@/assets/images/logo8.png'
import logo9 from '@/assets/images/logo9.png'
import logo10 from '@/assets/images/logo10.png'
import logo11 from '@/assets/images/logo11.png'
import logo12 from '@/assets/images/logo12.png'
import logo13 from '@/assets/images/logo13.jpg'
import logo14 from '@/assets/images/logo14.png'
import logo15 from '@/assets/images/logo15.jpg'
import logo16 from '@/assets/images/logo16.jpg'
import logo17 from '@/assets/images/logo17.jpg'
import logo18 from '@/assets/images/logo18.jpg'
import logo19 from '@/assets/images/logo19.jpg'
import logo20 from '@/assets/images/logo20.jpg'
import logo21 from '@/assets/images/logo21.jpg'
import logo22 from '@/assets/images/logo22.jpg'
import logo23 from '@/assets/images/logo23.jpg'
export default {
  name: 'HomePage',
  data () {
    return {
      Logo,
      logo1,
      logo2,
      logo3,
      logo4,
      logo5,
      logo6,
      logo7,
      logo8,
      logo9,
      logo10,
      logo11,
      logo12,
      logo13,
      logo14,
      logo15,
      logo16,
      logo17,
      logo18,
      logo19,
      logo20,
      logo21,
      logo22,
      logo23,
    }
  },
  created () {
    localStorage.removeItem('ScoreQuery')
    localStorage.removeItem('CertQuery')
  },
  mounted () {},
  methods: {
    go(name) {
      this.$router.push(name)
    }
  }
}
</script>

<style lang="less">
.homePage{
  background-color:#fff;
  min-height: 100vh;
  .logoImg {
    margin: 10vw auto 0;
    width: auto;
    height: 40vw;
    display: block;
  }
  h1 {
    font-size: 20px;
    text-align: center;
    margin-bottom: 10vw
  }
  .box{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    box-sizing: border-box;
    :after{
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 0 solid #ebedf0;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      border-top-width: 1px;
      border-left-width: 1px;
    }
    .box-item{
      width: 50%;
      min-width: 50%;
      text-align: center;
      position: relative;
      box-sizing: border-box;
      padding: 10px;
      img{
        max-height: 80px;
        max-width: 80%;
      }
      p{
        font-size: 13px;
      }
    }
  }
}
</style>
